import { eBranches } from "../../data/enums";
var LiveEventsTime = /** @class */ (function () {
    function LiveEventsTime() {
        var _this = this;
        this.GetTimeTextHashTablePerBranch = {};
        this.GetTimeTextHashTablePerBranch[eBranches.Soccer] = function (gameData) {
            var _a;
            var min = 0, sec = 0;
            if (gameData.Status === 1 || gameData.Status === 2) // First half / second half / ET
             {
                var delta = _this.timeControl.getServerTime().getTime() - gameData.LastTimeUpdate.getTime();
                var current = delta / 1000 + gameData.GameTime;
                min = Math.floor(current / 60);
                sec = Math.floor(current % 60);
                if (gameData.IsET === 1) {
                    (_a = _this.calculateSoccerTime(min, gameData, sec), min = _a.min, sec = _a.sec);
                }
            }
            return _this.convertToMilliseconds(min, sec);
        };
        this.GetTimeTextHashTablePerBranch[eBranches.Basketball] = function (gameData) {
            var _a;
            var min = 0, sec = 0;
            // basketball 1Q to 4thQ and overtime
            if (Math.abs(gameData.Status) >= 11 && Math.abs(gameData.Status) <= 14 || Math.abs(gameData.Status) === 60) {
                (_a = _this.calculateBasketBallTime(gameData, min, sec), min = _a.min, sec = _a.sec);
            }
            return _this.convertToMilliseconds(min, sec);
        };
        this.GetTimeTextHashTablePerBranch[eBranches.IceHockey] = function (gameData) {
            var _a;
            var min = 0, sec = 0;
            // Ice hockey 1Period to 3Period
            if (Math.abs(gameData.Status) >= 11 && Math.abs(gameData.Status) <= 13) {
                (_a = _this.calculateIceHockeyTime(gameData, min, sec), min = _a.min, sec = _a.sec);
            }
            return _this.convertToMilliseconds(min, sec);
        };
        this.GetTimeTextHashTablePerBranch[eBranches.Football] = this.GetTimeTextHashTablePerBranch[eBranches.Basketball];
    }
    LiveEventsTime.prototype.convertToMilliseconds = function (min, sec) {
        return (min * 60 + sec) * 1000;
    };
    LiveEventsTime.prototype.setTimeControlProvider = function (provider) {
        this.timeControl = provider;
    };
    LiveEventsTime.prototype.getTime = function (gameData, branchID) {
        if (!this.GetTimeTextHashTablePerBranch.hasOwnProperty(branchID) || !gameData) {
            return 0;
        }
        var timeInMilliseconds = this.GetTimeTextHashTablePerBranch[branchID](gameData);
        return timeInMilliseconds;
    };
    LiveEventsTime.prototype.calculateSoccerTime = function (min, gameData, sec) {
        if ((min >= 15 && gameData.Status === 1) || (min >= 60 && gameData.Status === 2)) {
            min = gameData.Status * 15;
            sec = 0;
        }
        else if (gameData.Status === 2) {
            min = min - 30;
        }
        return { min: min, sec: sec };
    };
    LiveEventsTime.prototype.calculateIceHockeyTime = function (gameData, min, sec) {
        if ((gameData.Status) > 0) {
            var delta = this.timeControl.getServerTime().getTime() - gameData.LastTimeUpdate.getTime();
            var current = gameData.GameTime - delta / 1000;
            min = Math.floor(current / 60);
            sec = Math.floor(current % 60);
            min = min < 0 ? 0 : min;
            sec = sec < 0 ? 0 : sec;
        }
        else {
            min = Math.floor(gameData.GameTime / 60);
            sec = Math.floor(gameData.GameTime % 60);
            min = min < 0 ? 0 : min;
            sec = sec < 0 ? 0 : sec;
        }
        return { min: min, sec: sec };
    };
    LiveEventsTime.prototype.calculateBasketBallTime = function (gameData, min, sec) {
        if ((gameData.Status) > 0) {
            var delta = this.timeControl.getServerTime().getTime() - gameData.LastTimeUpdate.getTime();
            var current = gameData.GameTime - delta / 1000;
            min = Math.floor(current / 60);
            sec = Math.floor(current % 60);
            min = min < 0 ? 0 : min;
            sec = sec < 0 ? 0 : sec;
        }
        else {
            min = Math.floor(gameData.GameTime / 60);
            sec = Math.floor(gameData.GameTime % 60);
            min = min < 0 ? 0 : min;
            sec = sec < 0 ? 0 : sec;
        }
        return { min: min, sec: sec };
    };
    return LiveEventsTime;
}());
export { LiveEventsTime };
/* instanbul ignore next */
export var liveEventsTime = new LiveEventsTime();
//# sourceMappingURL=LiveEventsTime.js.map